import React, { useState, createContext } from "react";

const AppContext = createContext();
const { Provider } = AppContext;

const AppProvider = ({ children }) => {
    const [formState, setFormState] = useState('form');

    const state = {
        formState,
    };

    const actions = {
        setFormState,
    };
    return <Provider value={{ ...state, ...actions }}>{children}</Provider>;
};

export { AppProvider, AppContext };
